import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SalesChart } from "../models/sales-chart";
import { SalesSum } from "../models/sales-sum";
import { ApiCallsService } from "../shared/api-calls.service";

@Injectable({ providedIn: "root" })
export class AdminService {
  constructor(
    private httpClient: HttpClient,
    private global: ApiCallsService
  ) { }
  token: any = "Authorization:Bearer " + localStorage.getItem("A_accesstoken");
  getOrderTracking(orderTransationStatusId: number, token: any) {
    return this.httpClient.get(
      this.global.getOrderTracking +
      "?orderTransationStatusId=" +
      orderTransationStatusId,
      { headers: token }
    );
  }
  login(data) {
    return this.httpClient.post(this.global.login, data);
  }

  forgetpassword(email) {
    return this.httpClient.get(this.global.forgetpassword + "?Email=" + email);
  }

  SetPassword(data: any) {
    return this.httpClient.post(this.global.SetPassword, data);
  }

  categoriesList(token: any) {
    return this.httpClient.get(this.global.CategoriesList, { headers: token });
  }
  AddCategory(categorydata: any, token: any) {
    return this.httpClient.post(this.global.addcategory, categorydata, {
      headers: token,
    });
  }
  addSubCategory(subcategorydata: any, token: any) {
    return this.httpClient.post(this.global.addSubCategories, subcategorydata, {
      headers: token,
    });
  }

  deleteCategories(Catid: any, token: any) {
    return this.httpClient.get(
      this.global.deleteCategories + "?CategoryId=" + Catid,
      { headers: token }
    );
  }
  DesigerwiseSales(id: any, token: any) {
    return this.httpClient.get(
      this.global.desigerSales + "?DesignerId=" + id,
      { headers: token }
    );
  }

  DesigerpoSales(id: any, token: any) {
    return this.httpClient.get(
      this.global.desigerPowise + "?DesignerId=" + id,
      { headers: token }
    );
  }

  categoryimagefileupload(Catid: any, token: any, data: any) {
    return this.httpClient.post(
      this.global.categoryimagefileupload + "?categoryId=" + Catid,
      data,
      { headers: token }
    );
  }
  getCategoryimages(Catid: any, token: any) {
    return this.httpClient.get(
      this.global.getMultipleimages + "?CategoryId=" + Catid,
      { headers: token }
    );
  }
  multiplecategoryimagefileupload(CategoryId: any, token: any, data: any) {
    return this.httpClient.post(
      this.global.multiplecategoryimagefileupload + "?CategoryId=" + CategoryId,
      data,
      { headers: token }
    );
  }

  deletecategorymultipleimage(CategoryId: any, token: any) {
    return this.httpClient.get(
      this.global.deletecategoryMultipleimage +
      "?CategoryImageId=" +
      CategoryId,
      { headers: token }
    );
  }

  SubCategories(Catid: any, token: any) {
    return this.httpClient.get(
      this.global.SubCategories + "?CategoryId=" + Catid,
      { headers: token }
    );
  }

  GetProducts(token: any) {
    return this.httpClient.get(this.global.getproducts, { headers: token });
  }

  AddProduct(productdata: any, token: any) {
    return this.httpClient.post(this.global.createproduct, productdata, {
      headers: token,
    });
  }

  getproductdata(pid: any, token: any) {
    return this.httpClient.get(
      this.global.getproductdata + "?ProductId=" + pid,
      { headers: token }
    );
  }

  createproductdata(pdata: any, token: any) {
    return this.httpClient.post(this.global.createproductdata, pdata, {
      headers: token,
    });
  }

  getproductimages(pid: any, token: any) {
    return this.httpClient.get(
      this.global.getproductimages + "?ProductId=" + pid,
      { headers: token }
    );
  }

  productimagesfileuploads(pid: any, token: any, data: any) {
    return this.httpClient.post(
      this.global.productimagesfileuploads + "?ProductId=" + pid,
      data,
      { headers: token }
    );
  }

  deleteproductimage(pid: any, token: any) {
    return this.httpClient.get(
      this.global.deleteproductimage + "?ProductImageId=" + pid,
      { headers: token }
    );
  }

  getproductdiscount(pid: any, token: any) {
    return this.httpClient.get(
      this.global.getproductdiscount + "?ProductId=" + pid,
      { headers: token }
    );
  }

  createproductdiscount(data: any, token: any) {
    return this.httpClient.post(this.global.createproductdiscount, data, {
      headers: token,
    });
  }

  deleteproduct(pid: any, token: any) {
    return this.httpClient.get(
      this.global.deleteproduct + "?ProductId=" + pid,
      { headers: token }
    );
  }

  getrelatedproducts(pid: any, token: any) {
    return this.httpClient.get(
      this.global.getrelatedproducts + "?productId=" + pid,
      { headers: token }
    );
  }

  addrelatedproducttoproduct(pdata: any, token: any) {
    return this.httpClient.post(this.global.addrelatedproducttoproduct, pdata, {
      headers: token,
    });
  }

  deleterelatedproduct(pid: any, token: any) {
    return this.httpClient.get(
      this.global.deleterelatedproduct + "?RelatedProductsId=" + pid,
      { headers: token }
    );
  }

  getproductcategories(pid: any, token: any) {
    return this.httpClient.get(
      this.global.getproductcategories + "?productId=" + pid,
      { headers: token }
    );
  }

  createproductcategories(pdata: any, token: any) {
    return this.httpClient.post(this.global.createproductcategories, pdata, {
      headers: token,
    });
  }
  deleteproductcategory(pid: any, token: any) {
    return this.httpClient.get(
      this.global.deleteproductcategory + "?ProductCategoryRelationId=" + pid,
      { headers: token }
    );
  }
  createproductinsinglerequest(pdata: any, token: any) {
    return this.httpClient.post(
      this.global.createproductinsinglerequest,
      pdata,
      { headers: token }
    );
  }

  getsizesforgender(token: any, gender?: any) {
    return this.httpClient.get(
      this.global.getsizesforgender + "?Gender=" + (gender ? gender : ""),
      { headers: token }
    );
  }
  getsizesforgender1(token: any, result) {
    return this.httpClient.get(
      this.global.getsizesforgender1 + "?CatagoryIDs=" + (result),
      { headers: token }
    );
  }


  getproductsinsinglerequest(token: any) {
    return this.httpClient.get(this.global.getproductsinsinglerequest, {
      headers: token,
    });
  }
  createsizes(sdata, token: any) {
    return this.httpClient.post(this.global.createsizes, sdata, {
      headers: token,
    });
  }

  changeSizeStatus(sizeId: number, token: any) {
    return this.httpClient.post(this.global.changeSizeStatus, sizeId, {
      headers: token,
    });
  }

  getsizes(token: any) {
    return this.httpClient.get(this.global.getsizes, { headers: token });
  }
  getcolors(token: any) {
    return this.httpClient.get(this.global.getcolors, { headers: token });
  }

  getMeterials(token: any) {
    return this.httpClient.get(this.global.getMeterials, { headers: token });
  }

  saveMaterial(sdata, token: any) {
    return this.httpClient.post(this.global.saveMaterial, sdata, {
      headers: token,
    });
  }

  changeMaterialStatus(materialId: number, token: any) {
    return this.httpClient.post(this.global.changeMaterialStatus, materialId, {
      headers: token,
    });
  }

  createcolor(sdata, token: any) {
    return this.httpClient.post(this.global.createcolor, sdata, {
      headers: token,
    });
  }

  changeColorStatus(colorId: number, token: any) {
    return this.httpClient.post(this.global.changColorStatus, colorId, {
      headers: token,
    });
  }

  getdesigners(token: any, designerId?: number) {
    return this.httpClient.get(
      this.global.getdesigners + "?DesignerId=" + (designerId || ""),
      { headers: token }
    );
  }

  createdesigner(sdata, token: any) {
    return this.httpClient.post(this.global.designer, sdata, {
      headers: token,
    });
  }

  changeDesignerStatus(designerId: number, token: any) {
    return this.httpClient.post(this.global.changeDesignerStatus, designerId, {
      headers: token,
    });
  }

  getcoupons(token: any) {
    return this.httpClient.get(this.global.getcoupons, { headers: token });
  }
  getdesignrequests(token: any) {
    return this.httpClient.get(this.global.getdesignrequests, {
      headers: token,
    });
  }

  AddEditCoupon(cdata, token: any) {
    return this.httpClient.post(this.global.AddEditCoupon, cdata, {
      headers: token,
    });
  }

  orders(token: any) {
    return this.httpClient.get(this.global.orders, { headers: token });
  }
  returnOrders(token: any) {
    return this.httpClient.get(this.global.returnOrders, { headers: token });
  }
  getOrderProductDetails(orderId: number, token: any) {
    return this.httpClient.get(
      this.global.getOrderProductDetails + "?orderId=" + orderId,
      { headers: token }
    );
  }
  getProductLikes(
    token: any
  ): Observable<
    Array<{
      productId: number;
      productName: string;
      count: number;
      imagePath: string;
    }>
  > {
    return this.httpClient.get<
      Array<{
        productId: number;
        productName: string;
        count: number;
        imagePath: string;
      }>
    >(this.global.getProductLikes, { headers: token });
  }

  getTransactions(token: any) {
    return this.httpClient.get(this.global.getTransactions, { headers: token });
  }

  getCustomers(token: any) {
    return this.httpClient.get(this.global.getCustomers, { headers: token });
  }

  changeUserStatus(userId: number, token: any) {
    return this.httpClient.post(this.global.changeUserStatus, userId, {
      headers: token,
    });
  }

  
  
  resetPassword(userId: number, token: any) {
    return this.httpClient.get(
      this.global.resetPassword + "?userId=" + userId,
      { headers: token }
    );
  }

  getOrderTransactions(token: any) {
    return this.httpClient.get(this.global.getOrderTransactions, {
      headers: token,
    });
  }

  updateTransationStatus(data: any, token: any) {
    return this.httpClient.post(this.global.updateTransationStatus, data, {
      headers: token,
    });
  }

  getReviewsRatings(token: any) {
    return this.httpClient.get(this.global.getReviewsRatings, {
      headers: token,
    });
  }

  saveReviewReplay(data: any, token: any) {
    return this.httpClient.post(this.global.saveReviewReplay, data, {
      headers: token,
    });
  }

  changeProductReviewStatus(productReviewRatingId: any, token: any) {
    return this.httpClient.post(
      this.global.changeProductReviewStatus,
      productReviewRatingId,
      {
        headers: token,
      }
    );
  }

  getPricesForFilter(
    token: any
  ): Observable<
    Array<{
      priceId: number;
      minPrice: number;
      maxPrice: number;
      status: boolean;
    }>
  > {
    return this.httpClient.get<
      Array<{
        priceId: number;
        minPrice: number;
        maxPrice: number;
        status: boolean;
      }>
    >(this.global.getPricesForFilter, {
      headers: token,
    });
  }

  saveFilterPrice(
    data: {
      priceId: number;
      minPrice: number;
      maxPrice: number;
    },
    token: any
  ) {
    return this.httpClient.post(this.global.saveFilterPrice, data, {
      headers: token,
    });
  }

  deleteFilterPrice(priceId: number, token: any) {
    return this.httpClient.post(this.global.deleteFilterPrice, priceId, {
      headers: token,
    });
  }

  changePriceStatus(priceId: number, token: any) {
    return this.httpClient.post(this.global.changePriceStatus, priceId, {
      headers: token,
    });
  }

  getDashboardCounts(
    token: any
  ): Observable<{
    totalOrders: number;
    totalSales: number;
    totalCustomers: number;
    totalDesigners: number;
  }> {
    return this.httpClient.get<{
      totalOrders: number;
      totalSales: number;
      totalCustomers: number;
      totalDesigners: number;
    }>(this.global.getDashboardCounts, {
      headers: token,
    });
  }
  getDashboardAnalytics(token: any) {
    return this.httpClient.get(this.global.getDashboardAnalytics, {
      headers: token,
    });
  }
  getsalesAnalytics(token: any) {
    return this.httpClient.get(this.global.getsalesAnalytics, {
      headers: token,
    });
  }
  getTopOrders(token: any) {
    return this.httpClient.get(this.global.getTopOrders, {
      headers: token,
    });
  }



  getDesignersProductCount(token: any) {
    return this.httpClient.get(this.global.getDesignersProductCount, {
      headers: token,
    });
  }

  getAllGraphDataByCustomDate(token: any, start, end, graphCountfor, id?) {
    let url = '';
    if (id) {
      url = `${this.global.getDesignerGraphDataByCustomDate}?DesignerId=${id}&FromDate=${start}&ToDate=${end}&GraphCountfor=${graphCountfor}`
    } else {
      url = `${this.global.getAllGraphDataByCustomDate}?FromDate=${start}&ToDate=${end}&GraphCountfor=${graphCountfor}`
    }
    return this.httpClient.get(url, {
      headers: token,
    });
  }

  getProductsForDesigner(id: number) {
    return this.httpClient.get(
      this.global.getProductsForDesigner + "?DesignerId=" + id
    );
  }

  getMonthWiseSales(months: number, token: any): Observable<Array<SalesChart>> {
    return this.httpClient.get<Array<SalesChart>>(
      this.global.getMonthWiseSales + "?months=" + months,
      {
        headers: token,
      }
    );
  }

  getYearWiseSales(years: number, token: any): Observable<Array<SalesChart>> {
    return this.httpClient.get<Array<SalesChart>>(
      this.global.getYearWiseSales + "?years=" + years,
      {
        headers: token,
      }
    );
  }

  getDesignerWiseSales(
    token: any,
    startTime?: Date,
    endTime?: Date
  ): Observable<Array<SalesSum>> {
    return this.httpClient
      .get<Array<SalesSum>>(
        this.global.getDesignerWiseSales +
        "?StartTime=" +
        (startTime || "") +
        "&EndTime=" +
        (endTime || ""),
        {
          headers: token,
        }
      )
      .pipe(
        map((_) => {
          return _ || [];
        })
      );
  }

  getCategoryWiseSales(
    token: any,
    startTime?: Date,
    endTime?: Date
  ): Observable<Array<SalesSum>> {
    return this.httpClient
      .get<Array<SalesSum>>(
        this.global.getCategoryWiseSales +
        "?StartTime=" +
        (startTime || "") +
        "&EndTime=" +
        (endTime || ""),
        {
          headers: token,
        }
      )
      .pipe(
        map((_) => {
          return _ || [];
        })
      );
  }

  //Delivery agent module
  getAllDeliveryLocation() {
    return this.httpClient.get(this.global.getAllDeliveryLocation, {
      headers: this.token,
    });
  }

  changeDeliveryLocationStatus(obj) {
    return this.httpClient.put(this.global.changeDeliveryLocationStatus, obj, {
      headers: this.token,
    });
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  keyPressAlphaNumeric(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressNumberLength(event, val) {
    if(event.target.value.length < val) {
      return true;
    } else {
      return false;
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

}
